import React, { useState } from 'react'
import { EditorView, highlightActiveLineGutter } from "@codemirror/view"
import CodeMirror from '@uiw/react-codemirror'
import {
  StreamLanguage,
  syntaxHighlighting,
  defaultHighlightStyle,
  foldGutter,
  indentOnInput,
} from '@codemirror/language'
import nativeSpelling from './nativeSpelling'
import { stex } from '@codemirror/legacy-modes/mode/stex'
import { grammarly } from './extensions/grammarly'

export const LatexExample = ({ fileName }: { fileName: string }) => {
  const [value, setValue] = useState<string | undefined>()

  if (value === undefined) {
    // Known issue: Throws error with the stex language extension
    // example from: 
    fetch(`./latex/${fileName}.txt`)
    .then((r) => r.text())
    .then(text  => {
      setValue(text)
    })  

  }

  (window as any).EditorView = EditorView

  const extensions = [
    EditorView.lineWrapping,
    EditorView.contentAttributes.of({ spellcheck: 'true' }),
    syntaxHighlighting(defaultHighlightStyle),
    nativeSpelling(),
    StreamLanguage.define(stex),
    foldGutter({
      openText: '▾',
      closedText: '▸',
    }),
    indentOnInput(),
    highlightActiveLineGutter(),
    grammarly()
  ]

  return (
    <CodeMirror 
      value={value}
      width="50em"
      height="80vh"
      extensions={extensions} 
      onChange={(value) => setValue(value)}
    />
  )
}
